webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MovingCost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Heuristic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CornerWalk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Direction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DeltaLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Delta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DeltaReversedDirection; });
var MovingCost = {
  Base: 10,
  Orthogonal: 10,
  Diagonal: 14,
  Turning: 4,
  Stay: 0
};

var Heuristic = {
  Manhattan: 0,
  Euclidean: 1,
  Octile: 2,
  Chebyshev: 3
};

var CornerWalk = {
  Orthogonal: 0,
  Diagonal: 1
};

var Direction = {
  BottomRight: 0,
  Bottom: 1,
  BottomLeft: 2,
  Left: 3,
  UpLeft: 4,
  Up: 5,
  UpRight: 6,
  Right: 7
};

var DeltaLength = 8;
var Delta = [{
  x: -1,
  y: -1
}, {
  x: -1,
  y: 0
}, {
  x: -1,
  y: 1
}, {
  x: 0,
  y: 1
}, {
  x: 1,
  y: 1
}, {
  x: 1,
  y: 0
}, {
  x: 1,
  y: -1
}, {
  x: 0,
  y: -1
}];
var DeltaReversedDirection = [Direction.BottomRight, Direction.Bottom, Direction.BottomLeft, Direction.Left, Direction.UpLeft, Direction.Up, Direction.UpRight, Direction.Right];

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PathFinder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Matrix__ = __webpack_require__(19);





var pathfinderId = 0;

function PathFinder(matrix) {
  Object.defineProperty(this, 'id', {
    value: pathfinderId++
  });

  this.matrix = matrix || {};

  this.isHistoryReady = false;
  this.history = [];

  this.history.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.matrix)));

  this.stepIndex = 0;
}

__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(PathFinder.prototype, {
  isBeginEndSame: function isBeginEndSame() {
    return this.matrix.begin.x == this.matrix.end.x && this.matrix.begin.y == this.matrix.end.y;
  },

  recordSteps: function recordSteps() {
    this.history.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.matrix)));
  },

  recordAllPath: function recordAllPath() {
    this.matrix.setAllPath();
    this.recordSteps();
    this.setIsHistoryReady(true);
  },

  recordBiAllPath: function recordBiAllPath(ai, bi) {
    this.matrix.setBiAllPath(ai, bi);
    this.recordSteps();
    this.setIsHistoryReady(true);
  },

  getFirstResult: function getFirstResult() {
    this.stepIndex = 1;
    return this.getCurrentMatrix();
  },

  getFinalResult: function getFinalResult() {
    this.stepIndex = this.history.length - 1;
    return this.getCurrentMatrix();
  },

  getCurrentMatrix: function getCurrentMatrix() {
    var matrixBase = this.history[this.stepIndex];
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_set_prototype_of___default()(matrixBase, __WEBPACK_IMPORTED_MODULE_3__Matrix__["a" /* Matrix */].prototype);
  },

  isNextStepAvaiable: function isNextStepAvaiable() {
    return this.stepIndex < this.history.length - 1;
  },

  getNextStepMatrix: function getNextStepMatrix() {
    if (this.isNextStepAvaiable()) {
      this.stepIndex++;
      return this.getCurrentMatrix();
    }
  },

  isPreviousStepAvailable: function isPreviousStepAvailable() {
    return this.stepIndex > 0;
  },

  getPreviousStepMatrix: function getPreviousStepMatrix() {
    if (this.isPreviousStepAvailable()) {
      this.stepIndex--;
      return this.getCurrentMatrix();
    }
  },

  setIsHistoryReady: function setIsHistoryReady(f) {
    this.isHistoryReady = f;
  },

  isPathFound: function isPathFound() {
    var endCube = this.matrix.getCubeFromXY(this.matrix.end.x, this.matrix.end.y);
    return endCube.isOpen || endCube.isVisited;
  },

  resetFinder: function resetFinder(matrix) {
    this.matrix = matrix;
    this.setIsHistoryReady(false);
    this.history = [];
    this.history.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.matrix)));
    this.stepIndex = 0;
  }
});



/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Matrix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Connstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cube__ = __webpack_require__(88);




var matrixId = 0;

function Matrix(width, height) {
  Object.defineProperty(this, 'id', {
    value: matrixId++
  });

  this.width = width || 10;
  this.height = height || 10;
  Object.defineProperty(this, 'size', {
    get: function get() {
      return this.width * this.height;
    },
    enumerable: true
  });

  this.sequence = 1;

  this.cubes = this.initCubes();

  this.cornerWalk = __WEBPACK_IMPORTED_MODULE_1__Connstants__["a" /* CornerWalk */].Orthogonal;
  this.heuristic = __WEBPACK_IMPORTED_MODULE_1__Connstants__["b" /* Heuristic */].Manhattan;

  this.graph = this.buildGraph();

  this.begin = {
    x: 0,
    y: 0
  };
  this.end = {
    x: 9,
    y: 9
  };

  this.setBegin(this.begin.x, this.begin.y);
  this.setEnd(this.end.x, this.end.y);
}

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(Matrix.prototype, {
  setWidthHeight: function setWidthHeight(w, h) {
    this.width = w;
    this.height = h;
  },

  getXYFromIndex: function getXYFromIndex(i) {
    return {
      x: parseInt(i / this.width),
      y: i % this.width
    };
  },

  getIndexFromXY: function getIndexFromXY(x, y) {
    return x * this.width + y;
  },

  getCubeFromXY: function getCubeFromXY(x, y) {
    return this.getCubeFromIndex(this.getIndexFromXY(x, y));
  },

  getCubeFromIndex: function getCubeFromIndex(i) {
    return i > -1 && i < this.size ? this.cubes[i] : {
      isObstacle: true
    };
  },

  setBegin: function setBegin(x, y) {
    var c = this.getCubeFromXY(x, y);
    this.begin.x = x;
    this.begin.y = y;
    c.isBegin = true;
    c.type = 'begin';
  },

  setEnd: function setEnd(x, y) {
    var c = this.getCubeFromXY(x, y);
    this.end.x = x;
    this.end.y = y;
    c.isEnd = true;
    c.type = 'end';
  },

  setTypeObstacle: function setTypeObstacle(x, y) {
    var c = this.getCubeFromXY(x, y);
    c.isObstacle = true;
    c.type = 'obstacle';
  },

  setTypePath: function setTypePath(x, y) {
    var c = this.getCubeFromXY(x, y);
    c.isObstacle = false;
    c.type = 'path';
  },

  setCornerWalk: function setCornerWalk(cw) {
    switch (cw) {
      case 'Orthogonal':
        this.cornerWalk = __WEBPACK_IMPORTED_MODULE_1__Connstants__["a" /* CornerWalk */].Orthogonal;
        break;
      case 'Diagonal':
        this.cornerWalk = __WEBPACK_IMPORTED_MODULE_1__Connstants__["a" /* CornerWalk */].Diagonal;
        break;
    }
  },

  setHeuristic: function setHeuristic(h) {
    switch (h) {
      case 'Manhattan':
        this.heuristic = __WEBPACK_IMPORTED_MODULE_1__Connstants__["b" /* Heuristic */].Manhattan;
        break;
      case 'Euclidean':
        this.heuristic = __WEBPACK_IMPORTED_MODULE_1__Connstants__["b" /* Heuristic */].Euclidean;
        break;
      case 'Octile':
        this.heuristic = __WEBPACK_IMPORTED_MODULE_1__Connstants__["b" /* Heuristic */].Octile;
        break;
      case 'Chebyshev':
        this.heuristic = __WEBPACK_IMPORTED_MODULE_1__Connstants__["b" /* Heuristic */].Chebyshev;
        break;
    }
  },

  isInsideBoundary: function isInsideBoundary(x, y) {
    return x > -1 && x < this.width && y > -1 && y < this.height;
  },

  isCubeWalkable: function isCubeWalkable(x, y) {
    return !this.getCubeFromXY(x, y).isObstacle && this.isInsideBoundary(x, y);
  },

  isCornerWalkable: function isCornerWalkable(x, y, d) {
    if (this.getCubeFromXY(x + __WEBPACK_IMPORTED_MODULE_1__Connstants__["c" /* Delta */][d].x, y + __WEBPACK_IMPORTED_MODULE_1__Connstants__["c" /* Delta */][d].y).isObstacle) {
      return false;
    }

    if (d == __WEBPACK_IMPORTED_MODULE_1__Connstants__["d" /* Direction */].UpLeft || d == __WEBPACK_IMPORTED_MODULE_1__Connstants__["d" /* Direction */].UpRight || d == __WEBPACK_IMPORTED_MODULE_1__Connstants__["d" /* Direction */].BottomRight || d == __WEBPACK_IMPORTED_MODULE_1__Connstants__["d" /* Direction */].BottomLeft) {
      if (this.cornerWalk == __WEBPACK_IMPORTED_MODULE_1__Connstants__["a" /* CornerWalk */].Orthogonal) {
        return false;
      } else if (this.cornerWalk == __WEBPACK_IMPORTED_MODULE_1__Connstants__["a" /* CornerWalk */].Diagonal) {
        if (this.getCubeFromXY(x + __WEBPACK_IMPORTED_MODULE_1__Connstants__["c" /* Delta */][d].x, y).isObstacle || this.getCubeFromXY(x, y + __WEBPACK_IMPORTED_MODULE_1__Connstants__["c" /* Delta */][d].y).isObstacle) {
          return false;
        }
      }
    }

    return true;
  },

  isDeltaCubeWalkable: function isDeltaCubeWalkable(x, y, d) {
    return !this.getCubeFromXY(x, y).isObstacle && this.isInsideBoundary(x + __WEBPACK_IMPORTED_MODULE_1__Connstants__["c" /* Delta */][d].x, y + __WEBPACK_IMPORTED_MODULE_1__Connstants__["c" /* Delta */][d].y) && this.isCornerWalkable(x, y, d);
  },

  heuristicManhattan: function heuristicManhattan(dx, dy) {
    return dx + dy;
  },

  heuristicEuclidean: function heuristicEuclidean(dx, dy) {
    return Math.sqrt(dx * dx + dy * dy);
  },

  heuristicOctile: function heuristicOctile(dx, dy) {
    var F = Math.SQRT2 - 1;
    return dx < dy ? F * dx + dy : F * dy + dx;
  },

  heuristicChebyshev: function heuristicChebyshev(dx, dy) {
    return Math.max(dx, dy);
  },

  heuristicAB: function heuristicAB(ax, ay, bx, by) {
    var dx = Math.abs(ax - bx);
    var dy = Math.abs(ay - by);
    switch (this.heuristic) {
      case __WEBPACK_IMPORTED_MODULE_1__Connstants__["b" /* Heuristic */].Manhattan:
        return this.heuristicManhattan(dx, dy);
      case __WEBPACK_IMPORTED_MODULE_1__Connstants__["b" /* Heuristic */].Euclidean:
        return this.heuristicEuclidean(dx, dy);
      case __WEBPACK_IMPORTED_MODULE_1__Connstants__["b" /* Heuristic */].Octile:
        return this.heuristicOctile(dx, dy);
      case __WEBPACK_IMPORTED_MODULE_1__Connstants__["b" /* Heuristic */].Chebyshev:
        return this.heuristicChebyshev(dx, dy);
    }
  },

  calculateCubesHeuristicAB: function calculateCubesHeuristicAB(x, y, tx, ty) {
    var c = this.getCubeFromXY(x, y);
    c.H = Math.round(this.heuristicAB(x, y, tx, ty)) * __WEBPACK_IMPORTED_MODULE_1__Connstants__["e" /* MovingCost */].Base;
  },

  heuristicToEnd: function heuristicToEnd(x, y) {
    return this.heuristicAB(x, y, this.end.x, this.end.y);
  },

  calculateCubesHeuristicToEnd: function calculateCubesHeuristicToEnd() {
    for (var i = 0; i < this.size; i++) {
      var xy = this.getXYFromIndex(i);
      this.getCubeFromIndex(i).H = Math.round(this.heuristicToEnd(xy.x, xy.y)) * __WEBPACK_IMPORTED_MODULE_1__Connstants__["e" /* MovingCost */].Base;
    }
  },

  initCubes: function initCubes() {
    var cubes = [];
    for (var i = 0; i < this.size; i++) {
      var c = new __WEBPACK_IMPORTED_MODULE_2__Cube__["a" /* Cube */]();
      c.index = i;
      var XY = this.getXYFromIndex(i);
      c.x = XY.x;
      c.y = XY.y;
      cubes.push(c);
    }
    return cubes;
  },

  clearMatrix: function clearMatrix() {
    this.sequence = 1;
    for (var i = 0; i < this.size; i++) {
      var c = this.getCubeFromIndex(i);
      c.isPath = false;
      c.father = null;
      c.fatherDirection = null;

      c.isRedBorder = false;
      c.isGreenBorder = false;
      c.isBlueBorder = false;

      c.isOpen = false;
      c.isClosed = false;
      c.F = 0.0;
      c.G = 0.0;
      c.H = 0.0;
      c.isShowFGH = false;

      c.isVisited = false;
      c.sequence = 0.0;

      c.markedByBegin = false;
      c.markedByEnd = false;
    }
  },

  resetMatrix: function resetMatrix() {
    this.sequence = 1;

    this.cubes = this.initCubes();

    this.graph = this.buildGraph();

    this.begin = {
      x: 0,
      y: 0
    };
    this.end = {
      x: 9,
      y: 9
    };

    this.setBegin(this.begin.x, this.begin.y);
    this.setEnd(this.end.x, this.end.y);
  },

  resetGraph: function resetGraph() {
    this.sequence = 1;

    this.clearMatrix();

    this.graph = this.buildGraph();
  },

  buildGraph: function buildGraph() {
    var graph = [];

    for (var i = 0; i < this.size; i++) {
      var arr = [];
      for (var j = 0; j < this.size; j++) {
        arr.push(Number.POSITIVE_INFINITY);
      }
      graph.push(arr);
    }

    for (var x = 0; x < this.width; x++) {
      for (var y = 0; y < this.height; y++) {
        var currentNodeIndex = this.getIndexFromXY(x, y);
        var currentNodeCube = this.getCubeFromIndex(currentNodeIndex);
        for (var d = 0; d < __WEBPACK_IMPORTED_MODULE_1__Connstants__["f" /* DeltaLength */]; d++) {
          var dx = x + __WEBPACK_IMPORTED_MODULE_1__Connstants__["c" /* Delta */][d].x;
          var dy = y + __WEBPACK_IMPORTED_MODULE_1__Connstants__["c" /* Delta */][d].y;

          if (this.isInsideBoundary(dx, dy) && this.isDeltaCubeWalkable(x, y, d)) {
            var deltaNodeIndex = this.getIndexFromXY(dx, dy);
            var deltaNodeCube = this.getCubeFromIndex(deltaNodeIndex);
            var addedCorner = d % 2 == 0 ? __WEBPACK_IMPORTED_MODULE_1__Connstants__["e" /* MovingCost */].Turning : __WEBPACK_IMPORTED_MODULE_1__Connstants__["e" /* MovingCost */].Stay;
            graph[currentNodeIndex][deltaNodeIndex] = deltaNodeCube.weight + addedCorner;
          }
        }
      }
    }

    return graph;
  },

  setCubeVisited: function setCubeVisited(x, y) {
    var c = this.getCubeFromXY(x, y);
    c.isClosed = true;
    c.isGreenBorder = true;
    c.isVisited = true;
    c.sequence = this.sequence++;
  },

  setCubeExtended: function setCubeExtended(x, y) {
    var c = this.getCubeFromXY(x, y);
    c.isOpen = true;
    c.isBlueBorder = true;
    c.isVisited = true;
    c.sequence = this.sequence++;
  },

  setCubePath: function setCubePath(x, y) {
    var c = this.getCubeFromXY(x, y);
    c.isRedBorder = true;
    c.isPath = true;
  },

  setCubeFather: function setCubeFather(x, y, fi, fd) {
    var c = this.getCubeFromXY(x, y);
    c.father = fi;
    c.fatherDirection = fd;
  },

  setCubeG: function setCubeG(x, y, G) {
    var c = this.getCubeFromXY(x, y);
    c.G = G;
    c.F = c.G + c.H;
    c.isShowFGH = true;
  },

  setAllPath: function setAllPath() {
    var pathCube = this.getCubeFromXY(this.end.x, this.end.y);
    while (pathCube) {
      this.setCubePath(pathCube.x, pathCube.y);
      if (pathCube.father) {
        pathCube = this.getCubeFromIndex(pathCube.father);
      } else {
        pathCube = null;
      }
    }
  },

  setBiAllPath: function setBiAllPath(ai, bi) {
    var pathCube = this.getCubeFromIndex(ai);
    while (pathCube) {
      this.setCubePath(pathCube.x, pathCube.y);
      pathCube = this.getCubeFromIndex(pathCube.father);
    }

    pathCube = this.getCubeFromIndex(bi);
    while (pathCube) {
      this.setCubePath(pathCube.x, pathCube.y);
      pathCube = this.getCubeFromIndex(pathCube.father);
    }
  }
});



/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(151)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(159),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports) {

var messages = {
  'en': {
    run: 'Run',
    previous: 'Previous',
    next: 'Next',
    clear: 'Clear',
    reset: 'Reset'
  },
  'zh-CN': {}
};

module.exports = messages;

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(102);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({ state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */], mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */], actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */], getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* default */] }));

/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(161),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_matrix_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_matrix_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_matrix_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_controls_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_controls_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_controls_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tutorial_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tutorial_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tutorial_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    matrix: __WEBPACK_IMPORTED_MODULE_0__components_matrix_vue___default.a,
    controls: __WEBPACK_IMPORTED_MODULE_1__components_controls_vue___default.a,
    tutorial: __WEBPACK_IMPORTED_MODULE_2__components_tutorial_vue___default.a
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Matrix__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_finders_index__ = __webpack_require__(100);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      alg: '',
      finder: 'AStar',
      finders: [{
        value: 'AStar',
        label: 'AStar'
      }, {
        value: 'JumpPoint',
        label: 'JumpPoint'
      }, {
        value: 'BiAStar',
        label: 'BiAStar'
      }, {
        value: 'AStarHeap',
        label: 'AStarHeap'
      }, {
        value: 'BiAStarHeap',
        label: 'BiAStarHeap'
      }, {
        value: 'BFS',
        label: 'BFS'
      }, {
        value: 'BiBFS',
        label: 'BiBFS'
      }, {
        value: 'DFS',
        label: 'DFS'
      }, {
        value: 'BiDFS',
        label: 'BiDFS'
      }, {
        value: 'Dijkstar',
        label: 'Dijkstar'
      }, {
        value: 'FloydWarshall',
        label: 'FloydWarshall'
      }],
      cornerWalk: 'Orthogonal',
      heuristic: 'Manhattan'
    };
  },
  mounted: function mounted() {
    this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["a" /* AStar */](this.matrix);
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['matrix']), {
    isPreviousButton: function isPreviousButton() {
      if (this.alg == '') {
        return true;
      } else {
        if (this.alg.isHistoryReady && this.alg.isPreviousStepAvailable()) {
          return false;
        } else {
          return true;
        }
      }
    },
    isNextButton: function isNextButton() {
      if (this.alg == '' || !this.alg.isHistoryReady) {
        return false;
      } else {
        if (this.alg.isNextStepAvaiable()) {
          return false;
        } else {
          return true;
        }
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATE_MATRIX']), {
    run: function run() {
      this.clear();
      var flag = this.alg.findPath();
      if (flag) {
        this.$store.commit('UPDATE_MATRIX', this.alg.getFinalResult());
      } else {
        this.$message({
          showClose: true,
          message: 'Oops, Fail to run.',
          type: 'error'
        });
      }
    },
    clear: function clear() {
      this.matrix.clearMatrix();
      this.matrix.resetGraph();
      this.alg.resetFinder(this.matrix);
    },
    reset: function reset() {
      this.matrix.resetMatrix();
      this.matrix.setCornerWalk(this.cornerWalk);
      this.matrix.setHeuristic(this.heuristic);
      this.alg.resetFinder(this.matrix);
    },
    previous: function previous() {
      if (this.alg.isPreviousStepAvailable()) {
        this.$store.commit('UPDATE_MATRIX', this.alg.getPreviousStepMatrix());
      } else {
        this.$message({
          showClose: true,
          message: 'No previous step.',
          type: 'error'
        });
      }
    },
    next: function next() {
      if (!this.alg.isHistoryReady) {
        var flag = this.alg.findPath();
        if (flag) {
          this.$store.commit('UPDATE_MATRIX', this.alg.getFirstResult());
        } else {
          this.$message({
            showClose: true,
            message: 'Oops, Fail to run.',
            type: 'error'
          });
        }
      } else {
        if (this.alg.isNextStepAvaiable()) {
          this.$store.commit('UPDATE_MATRIX', this.alg.getNextStepMatrix());
        } else {
          this.$message({
            showClose: true,
            message: 'No next step.',
            type: 'error'
          });
        }
      }
    },
    selectFinder: function selectFinder(f) {
      this.clear();
      switch (f) {
        case 'AStar':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["a" /* AStar */](this.matrix);
          break;
        case 'JumpPoint':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["b" /* JumpPoint */](this.matrix);
          break;
        case 'BiAStar':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["c" /* BiAStar */](this.matrix);
          break;
        case 'AStarHeap':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["d" /* AStarHeap */](this.matrix);
          break;
        case 'BiAStarHeap':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["e" /* BiAStarHeap */](this.matrix);
          break;
        case 'BFS':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["f" /* BFS */](this.matrix);
          break;
        case 'BiBFS':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["g" /* BiBFS */](this.matrix);
          break;
        case 'DFS':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["h" /* DFS */](this.matrix);
          break;
        case 'BiDFS':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["i" /* BiDFS */](this.matrix);
          break;
        case 'Dijkstar':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["j" /* Dijkstar */](this.matrix);
          break;
        case 'FloydWarshall':
          this.alg = new __WEBPACK_IMPORTED_MODULE_3__model_finders_index__["k" /* FloydWarshall */](this.matrix);
          break;
      }
    },
    selectCornerWalk: function selectCornerWalk(cw) {
      this.matrix.setCornerWalk(cw);
      this.matrix.resetGraph();
      this.alg.resetFinder(this.matrix);
    },
    selectHeuristic: function selectHeuristic(h) {
      this.matrix.setHeuristic(h);
      this.matrix.resetGraph();
      this.alg.resetFinder(this.matrix);
    }
  })

});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["default"] = ({

  props: ['index'],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['matrix', 'lastClickedCubeIndex', 'selectedCubeType']), {
    cubeIndex: function cubeIndex() {
      return this.index - 1;
    },
    cube: function cube() {
      return this.matrix.getCubeFromIndex(this.cubeIndex);
    },
    gridR: function gridR() {
      return parseInt(this.cubeIndex / 10) + 1;
    },
    gridC: function gridC() {
      return parseInt(this.cubeIndex % 10) + 1;
    },
    direction: function direction() {
      return 'rotate(' + 45 * (this.cube.fatherDirection + 1) + 'deg)';
    },
    cubeType: function cubeType() {
      return 'cube-' + this.cube.type;
    },
    borderType: function borderType() {
      if (this.cubeIndex == this.lastClickedCubeIndex) {
        return 'cube-border-clicked';
      } else if (this.cube.isRedBorder) {
        return 'cube-border-red';
      } else if (this.cube.isGreenBorder) {
        return 'cube-border-green';
      } else if (this.cube.isBlueBorder) {
        return 'cube-border-blue';
      } else if (this.cube.type == 'obstacle') {
        return 'cube-border-obstacle-color';
      } else {
        return 'cube-border-normal';
      }
    },
    indicatorType: function indicatorType() {
      if (this.cube.isPath) {
        return 'indicator-path';
      } else if (this.cube.isVisited) {
        return 'indicator-visited';
      }
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATE_LAST_CLICKED_CUBE_INDEX', 'UPDATE_SELECTED_CUBE_TYPE']), {
    cubeMouseDown: function cubeMouseDown() {
      var cubeXY = this.matrix.getXYFromIndex(this.cubeIndex);
      if (this.cube.type == 'begin' || this.cube.type == 'end') {
        this.$store.commit('UPDATE_SELECTED_CUBE_TYPE', this.cube.type);
        this.$store.commit('UPDATE_LAST_CLICKED_CUBE_INDEX', this.cubeIndex);
      } else {
        if (this.cube.type == 'path') {
          this.matrix.setTypeObstacle(cubeXY.x, cubeXY.y);
          this.$store.commit('UPDATE_SELECTED_CUBE_TYPE', 'obstacle');
        } else if (this.cube.type == 'obstacle') {
          this.matrix.setTypePath(cubeXY.x, cubeXY.y);
          this.$store.commit('UPDATE_SELECTED_CUBE_TYPE', 'path');
        }
      }
    },
    cubeMouseUp: function cubeMouseUp() {
      this.$store.commit('UPDATE_SELECTED_CUBE_TYPE', '');
    },
    cubeMouseEnter: function cubeMouseEnter() {
      var cubeXY = this.matrix.getXYFromIndex(this.cubeIndex);
      if (this.selectedCubeType) {
        if (this.selectedCubeType != 'begin' && this.selectedCubeType != 'end') {
          if (this.selectedCubeType == 'path') {
            this.matrix.setTypePath(cubeXY.x, cubeXY.y);
          } else if (this.selectedCubeType == 'obstacle') {
            this.matrix.setTypeObstacle(cubeXY.x, cubeXY.y);
          }
          this.$store.commit('UPDATE_LAST_CLICKED_CUBE_INDEX', this.cubeIndex);
        } else {
          if (this.cube.type != 'begin' && this.cube.type != 'end') {
            if (this.selectedCubeType == 'begin') {
              this.matrix.setBegin(cubeXY.x, cubeXY.y);
            } else if (this.selectedCubeType == 'end') {
              this.matrix.setEnd(cubeXY.x, cubeXY.y);
            }

            var lasyXY = this.matrix.getXYFromIndex(this.lastClickedCubeIndex);
            this.matrix.setTypePath(lasyXY.x, lasyXY.y);
            this.$store.commit('UPDATE_LAST_CLICKED_CUBE_INDEX', this.cubeIndex);
          }
        }
      }
    }
  })
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_Matrix__ = __webpack_require__(19);








/* harmony default export */ __webpack_exports__["default"] = ({
  beforeMount: function beforeMount() {
    var matrix = new __WEBPACK_IMPORTED_MODULE_3__model_Matrix__["a" /* Matrix */]();
    this.$store.commit('UPDATE_MATRIX', matrix);
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isLoading'])),

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATE_MATRIX'])),

  components: {
    cube: __WEBPACK_IMPORTED_MODULE_2__cube___default.a
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cube__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__cube__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      start: {
        type: 'begin'
      }
    };
  },


  components: {
    cube: __WEBPACK_IMPORTED_MODULE_0__cube___default.a
  }

});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_i18n__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__i18n__);








var isDebug_mode = "production" !== 'production';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = isDebug_mode;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.silent = !isDebug_mode;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);


var i18n = new __WEBPACK_IMPORTED_MODULE_3_vue_i18n__["a" /* default */]({ locale: 'en', fallbackLocale: 'en', messages: __WEBPACK_IMPORTED_MODULE_6__i18n___default.a });

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({ el: '#app', store: __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */], i18n: i18n, template: '<App/>', components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
    } });

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cube; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var cubeId = 0;

function Cube() {
  Object.defineProperty(this, 'id', {
    value: cubeId++
  });

  this.index = 0;
  this.x = 0;
  this.y = 0;

  this.isBegin = false;
  this.isEnd = false;
  this.isObstacle = false;

  this.type = 'path';
  this.walkingCost = 0;

  this.isPath = false;
  this.father = null;
  this.fatherDirection = null;

  this.isRedBorder = false;
  this.isGreenBorder = false;
  this.isBlueBorder = false;

  this.isOpen = false;
  this.isClosed = false;
  this.F = 0.0;
  this.G = 0.0;
  this.H = 0.0;
  this.isShowFGH = false;

  this.isVisited = false;
  this.sequence = 0.0;

  var _weightValue = 10.0;
  Object.defineProperty(this, 'weight', {
    get: function get() {
      if (this.isObstacle) {
        return Number.POSITIVE_INFINITY;
      } else {
        return _weightValue;
      }
    },
    set: function set(newValue) {
      if (newValue >= 0) {
        this.isObstacle = false;
        _weightValue = newValue;
      } else {
        this.isObstacle = true;
      }
    },
    enumerable: true
  });

  this.markedByBegin = false;
  this.markedByEnd = false;
}

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(Cube.prototype, {});



/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AStar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function AStar(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  var _openlist = [];

  function getMinOpenlist(matrix) {
    var temp = _openlist[0];
    var l = _openlist.length;
    for (var i = 1; i < l; i++) {
      if (matrix.getCubeFromIndex(_openlist[0]).F > matrix.getCubeFromIndex(_openlist[i]).F) {
        temp = _openlist[i];
        _openlist[i] = _openlist[0];
        _openlist[0] = temp;
      }
    }
  }

  this.findPath = function () {
    _openlist = [];
    var _currentCube = null;

    if (this.isBeginEndSame()) {
      return true;
    }

    this.matrix.calculateCubesHeuristicToEnd();

    _openlist.push(this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y));

    while (_openlist.length > 0) {
      getMinOpenlist(this.matrix);

      _currentCube = this.matrix.getCubeFromIndex(_openlist.shift());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isClosed) {
            var tempG = i % 2 == 0 ? _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Diagonal : _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Orthogonal;

            if (!deltaCube.isOpen) {
              _openlist.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
              this.matrix.setCubeG(deltaCubeX, deltaCubeY, tempG);
              this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);
              this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);
            } else {
              if (tempG < deltaCube.G) {
                this.matrix.setCubeG(deltaCubeX, deltaCubeY, tempG);
                this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);
              }
            }

            if (this.isPathFound()) {
              this.recordAllPath();
              return true;
            }

            this.recordSteps();
          }
        }
      }
    }

    return false;
  };
}

AStar.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AStarHeap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function AStarHeap(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  var _openlist = [];

  function popBinaryHeap(matrix) {
    if (_openlist.length == 1) return;
    _openlist[1] = _openlist.pop();
    var l = _openlist.length;
    var v = 1;
    var u;
    while (true) {
      u = v;
      if (2 * u + 1 <= l) {
        if (matrix.getCubeFromIndex(_openlist[u]).F >= matrix.getCubeFromIndex(_openlist[2 * u]).F) {
          v = 2 * u;
        }
        if (matrix.getCubeFromIndex(_openlist[v]).F >= matrix.getCubeFromIndex(_openlist[2 * u + 1]).F) {
          v = 2 * u + 1;
        }
      } else {
        if (2 * u <= l) {
          if (matrix.getCubeFromIndex(_openlist[u]).F >= matrix.getCubeFromIndex(_openlist[2 * u]).F) {
            v = 2 * u;
          }
        }
      }

      var temp;
      if (u != v) {
        temp = _openlist[u];
        _openlist[u] = _openlist[v];
        _openlist[v] = temp;
      } else {
        break;
      }
    }
  }

  function sortBinaryHeap(matrix) {
    var temp;
    var l = _openlist.length - 1;
    while (l != 1) {
      var l2 = parseInt(l / 2);
      if (matrix.getCubeFromIndex(_openlist[l]).F <= matrix.getCubeFromIndex(_openlist[l2]).F) {
        temp = _openlist[l2];
        _openlist[l2] = _openlist[l];
        _openlist[l] = temp;
        l = l2;
      } else {
        break;
      }
    }
  }

  this.findPath = function () {
    _openlist = [];
    var _currentCube = null;

    if (this.isBeginEndSame()) {
      return true;
    }

    this.matrix.calculateCubesHeuristicToEnd();

    _openlist.push(0);
    _openlist.push(this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y));

    while (_openlist.length > 1) {
      _currentCube = this.matrix.getCubeFromIndex(_openlist[1]);
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      popBinaryHeap(this.matrix);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isClosed) {
            var tempG = i % 2 == 0 ? _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Diagonal : _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Orthogonal;

            if (!deltaCube.isOpen) {
              _openlist.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
              this.matrix.setCubeG(deltaCubeX, deltaCubeY, tempG);
              this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);
              this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);
            } else {
              if (tempG < deltaCube.G) {
                this.matrix.setCubeG(deltaCubeX, deltaCubeY, tempG);
                this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);
              }
            }

            if (this.isPathFound()) {
              this.recordAllPath();
              return true;
            }

            sortBinaryHeap(this.matrix);

            this.recordSteps();
          }
        }
      }
    }

    return false;
  };
}

AStarHeap.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BFS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function BFS(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  var _visitlist = [];

  this.findPath = function () {
    _visitlist = [];
    var _currentCube = null;

    if (this.isBeginEndSame()) {
      return true;
    }

    _visitlist.push(this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y));

    while (_visitlist.length > 0) {
      _currentCube = this.matrix.getCubeFromIndex(_visitlist.shift());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isVisited) {
            _visitlist.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

            if (this.isPathFound()) {
              this.recordAllPath();
              return true;
            }

            this.recordSteps();
          }
        }
      }
    }

    return false;
  };
}

BFS.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BiAStar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function BiAStar(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  var _beginOpenList = [];
  var _endOpenList = [];

  function getMinOpenlist(openlist, matrix) {
    var temp = openlist[0];
    var l = openlist.length;
    for (var i = 1; i < l; i++) {
      if (matrix.getCubeFromIndex(openlist[0]).F > matrix.getCubeFromIndex(openlist[i]).F) {
        temp = openlist[i];
        openlist[i] = openlist[0];
        openlist[0] = temp;
      }
    }
  }

  this.findPath = function () {
    _beginOpenList = [];
    _endOpenList = [];
    var _currentCube = null;

    if (this.isBeginEndSame()) {
      return true;
    }

    _beginOpenList.push(this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y));
    _endOpenList.push(this.matrix.getIndexFromXY(this.matrix.end.x, this.matrix.end.y));

    while (_beginOpenList.length > 0 && _endOpenList.length > 0) {
      getMinOpenlist(_beginOpenList, this.matrix);

      _currentCube = this.matrix.getCubeFromIndex(_beginOpenList.shift());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isClosed) {

            if (deltaCube.markedByEnd) {
              this.recordBiAllPath(_currentCube.index, deltaCube.index);
              return true;
            }

            this.matrix.calculateCubesHeuristicAB(deltaCubeX, deltaCubeY, this.matrix.end.x, this.matrix.end.y);
            var tempG = i % 2 == 0 ? _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Diagonal : _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Orthogonal;

            if (!deltaCube.markedByBegin && !deltaCube.markedByEnd || tempG < deltaCube.G) {
              this.matrix.setCubeG(deltaCubeX, deltaCubeY, tempG);
              this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

              if (!deltaCube.markedByBegin && !deltaCube.markedByEnd) {
                _beginOpenList.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
                deltaCube.markedByBegin = true;
              }
            }

            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            this.recordSteps();
          }
        }
      }

      getMinOpenlist(_endOpenList, this.matrix);

      _currentCube = this.matrix.getCubeFromIndex(_endOpenList.shift());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isClosed) {

            if (deltaCube.markedByBegin) {
              this.recordBiAllPath(_currentCube.index, deltaCube.index);
              return true;
            }

            this.matrix.calculateCubesHeuristicAB(deltaCubeX, deltaCubeY, this.matrix.begin.x, this.matrix.begin.y);
            var tempG = i % 2 == 0 ? _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Diagonal : _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Orthogonal;

            if (!deltaCube.markedByBegin && !deltaCube.markedByEnd || tempG < deltaCube.G) {
              this.matrix.setCubeG(deltaCubeX, deltaCubeY, tempG);
              this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

              if (!deltaCube.markedByBegin && !deltaCube.markedByEnd) {
                _endOpenList.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
                deltaCube.markedByEnd = true;
              }
            }

            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            this.recordSteps();
          }
        }
      }
    }

    return false;
  };
}

BiAStar.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BiAStarHeap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function BiAStarHeap(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  var _beginOpenList = [];
  var _endOpenList = [];

  function popBinaryHeap(openlist, matrix) {
    if (openlist.length == 1) return;
    openlist[1] = openlist.pop();
    var l = openlist.length;
    var v = 1;
    var u;
    while (true) {
      u = v;
      if (2 * u + 1 <= l) {
        if (matrix.getCubeFromIndex(openlist[u]).F >= matrix.getCubeFromIndex(openlist[2 * u]).F) {
          v = 2 * u;
        }
        if (matrix.getCubeFromIndex(openlist[v]).F >= matrix.getCubeFromIndex(openlist[2 * u + 1]).F) {
          v = 2 * u + 1;
        }
      } else {
        if (2 * u <= l) {
          if (matrix.getCubeFromIndex(openlist[u]).F >= matrix.getCubeFromIndex(openlist[2 * u]).F) {
            v = 2 * u;
          }
        }
      }

      var temp;
      if (u != v) {
        temp = openlist[u];
        openlist[u] = openlist[v];
        openlist[v] = temp;
      } else {
        break;
      }
    }
  }

  function sortBinaryHeap(openlist, matrix) {
    var temp;
    var l = openlist.length - 1;
    while (l != 1) {
      var l2 = parseInt(l / 2);
      if (matrix.getCubeFromIndex(openlist[l]).F < matrix.getCubeFromIndex(openlist[l2]).F) {
        temp = openlist[l2];
        openlist[l2] = openlist[l];
        openlist[l] = temp;
        l = l2;
      } else {
        break;
      }
    }
  }

  this.findPath = function () {
    _beginOpenList = [];
    _endOpenList = [];
    var _currentCube = null;

    if (this.isBeginEndSame()) {
      return true;
    }

    _beginOpenList.push(0);
    _beginOpenList.push(this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y));
    _endOpenList.push(0);
    _endOpenList.push(this.matrix.getIndexFromXY(this.matrix.end.x, this.matrix.end.y));

    while (_beginOpenList.length > 0 && _endOpenList.length > 0) {
      _currentCube = this.matrix.getCubeFromIndex(_beginOpenList[1]);
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      popBinaryHeap(_beginOpenList, this.matrix);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isClosed) {

            if (deltaCube.markedByEnd) {
              this.recordBiAllPath(_currentCube.index, deltaCube.index);
              return true;
            }

            this.matrix.calculateCubesHeuristicAB(deltaCubeX, deltaCubeY, this.matrix.end.x, this.matrix.end.y);
            var tempG = i % 2 == 0 ? _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Diagonal : _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Orthogonal;

            if (!deltaCube.markedByBegin && !deltaCube.markedByEnd || tempG < deltaCube.G) {
              this.matrix.setCubeG(deltaCubeX, deltaCubeY, tempG);
              this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

              if (!deltaCube.markedByBegin && !deltaCube.markedByEnd) {
                _beginOpenList.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
                deltaCube.markedByBegin = true;
              }
            }

            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            sortBinaryHeap(_beginOpenList, this.matrix);

            this.recordSteps();
          }
        }
      }

      _currentCube = this.matrix.getCubeFromIndex(_endOpenList[1]);
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      popBinaryHeap(_endOpenList, this.matrix);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isClosed) {

            if (deltaCube.markedByBegin) {
              this.recordBiAllPath(_currentCube.index, deltaCube.index);
              return true;
            }

            this.matrix.calculateCubesHeuristicAB(deltaCubeX, deltaCubeY, this.matrix.begin.x, this.matrix.begin.y);
            var tempG = i % 2 == 0 ? _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Diagonal : _currentCube.G + __WEBPACK_IMPORTED_MODULE_3__Connstants__["e" /* MovingCost */].Orthogonal;

            if (!deltaCube.markedByBegin && !deltaCube.markedByEnd || tempG < deltaCube.G) {
              this.matrix.setCubeG(deltaCubeX, deltaCubeY, tempG);
              this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

              if (!deltaCube.markedByBegin && !deltaCube.markedByEnd) {
                _endOpenList.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
                deltaCube.markedByEnd = true;
              }
            }

            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            this.recordSteps();
          }
        }
      }
    }

    return false;
  };
}

BiAStarHeap.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BiBFS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function BiBFS(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  var _beginVisitList = [];
  var _endVisitList = [];

  this.findPath = function () {
    _beginVisitList = [];
    _endVisitList = [];
    var _currentCube = null;

    if (this.isBeginEndSame()) {
      return true;
    }

    _beginVisitList.push(this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y));
    _endVisitList.push(this.matrix.getIndexFromXY(this.matrix.end.x, this.matrix.end.y));

    while (_beginVisitList.length > 0 && _endVisitList.length > 0) {
      _currentCube = this.matrix.getCubeFromIndex(_beginVisitList.shift());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);

          if (deltaCube.markedByEnd) {
            this.recordBiAllPath(_currentCube.index, deltaCube.index);
            return true;
          }

          if (!deltaCube.isVisited) {
            _beginVisitList.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
            deltaCube.markedByBegin = true;
            this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            this.recordSteps();
          }
        }
      }

      _currentCube = this.matrix.getCubeFromIndex(_endVisitList.shift());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);

          if (deltaCube.markedByBegin) {
            this.recordBiAllPath(_currentCube.index, deltaCube.index);
            return true;
          }

          if (!deltaCube.isVisited) {
            _endVisitList.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
            deltaCube.markedByEnd = true;
            this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            this.recordSteps();
          }
        }
      }
    }

    return false;
  };
}

BiBFS.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BiDFS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function BiDFS(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  var _beginVisitList = [];
  var _endVisitList = [];

  this.findPath = function () {
    _beginVisitList = [];
    _endVisitList = [];
    var _currentCube = null;

    if (this.isBeginEndSame()) {
      return true;
    }

    _beginVisitList.push(this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y));
    _endVisitList.push(this.matrix.getIndexFromXY(this.matrix.end.x, this.matrix.end.y));

    while (_beginVisitList.length > 0 && _endVisitList.length > 0) {
      _currentCube = this.matrix.getCubeFromIndex(_beginVisitList.pop());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);

          if (deltaCube.markedByEnd) {
            this.recordBiAllPath(_currentCube.index, deltaCube.index);
            return true;
          }

          if (!deltaCube.isVisited) {
            _beginVisitList.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
            deltaCube.markedByBegin = true;
            this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            this.recordSteps();
          }
        }
      }

      _currentCube = this.matrix.getCubeFromIndex(_endVisitList.pop());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);

          if (deltaCube.markedByBegin) {
            this.recordBiAllPath(_currentCube.index, deltaCube.index);
            return true;
          }

          if (!deltaCube.isVisited) {
            _endVisitList.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
            deltaCube.markedByEnd = true;
            this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            this.recordSteps();
          }
        }
      }
    }

    return false;
  };
}

BiDFS.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DFS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function DFS(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  var _visitlist = [];

  this.findPath = function () {
    _visitlist = [];
    var _currentCube = null;

    if (this.isBeginEndSame()) {
      return true;
    }

    _visitlist.push(this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y));

    while (_visitlist.length > 0) {
      _currentCube = this.matrix.getCubeFromIndex(_visitlist.pop());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = _currentCube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = _currentCube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(_currentCube.x, _currentCube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isVisited) {
            _visitlist.push(this.matrix.getIndexFromXY(deltaCubeX, deltaCubeY));
            this.matrix.setCubeExtended(deltaCubeX, deltaCubeY);

            this.matrix.setCubeFather(deltaCubeX, deltaCubeY, _currentCube.index, __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][i]);

            if (this.isPathFound()) {
              this.recordAllPath();
              return true;
            }

            this.recordSteps();
          }
        }
      }
    }

    return false;
  };
}

DFS.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dijkstar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function Dijkstar(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  this.findPath = function () {
    var nodesSize = this.matrix.size;
    var beginNode = this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y);
    var endNode = this.matrix.getIndexFromXY(this.matrix.end.x, this.matrix.end.y);

    var distance = [];
    var previous = [];
    var isVisited = [];
    for (var i = 0; i < nodesSize; i++) {
      distance[i] = Number.POSITIVE_INFINITY;
      previous[i] = -1;
      isVisited[i] = false;
    }
    distance[beginNode] = 0;

    var shortestNode = null;
    var shortestNodeCube = null;
    var deltaCube = null;

    for (var i = 0; i < nodesSize; i++) {
      var tempSide = Number.POSITIVE_INFINITY;

      for (var j = 0; j < nodesSize; j++) {
        if (!isVisited[j] && distance[j] < tempSide) {
          shortestNode = j;
          tempSide = distance[j];
        }
      }

      isVisited[shortestNode] = true;
      shortestNodeCube = this.matrix.getCubeFromIndex(shortestNode);
      shortestNodeCube.isGreenBorder = true;
      shortestNodeCube.isVisited = true;
      shortestNodeCube.sequence = this.sequence++;
      shortestNodeCube.F = tempSide;
      shortestNodeCube.isShowFGH = true;

      for (var j = 0; j < nodesSize; j++) {
        if (!isVisited[j] && this.matrix.graph[shortestNode][j] < Number.POSITIVE_INFINITY) {
          var newDistance = distance[shortestNode] + this.matrix.graph[shortestNode][j];
          if (newDistance <= distance[j]) {
            distance[j] = newDistance;
            previous[j] = shortestNode;

            deltaCube = this.matrix.getCubeFromIndex(j);
            deltaCube.isBlueBorder = true;
            deltaCube.sequence = this.sequence++;
            deltaCube.F = newDistance;
            deltaCube.isShowFGH = true;

            if (j == endNode) {
              var previousPathNode = this.matrix.getCubeFromIndex(endNode);
              var path = previous[endNode];
              var pathNode = null;
              while (path != -1) {
                pathNode = this.matrix.getCubeFromIndex(path);
                previousPathNode.father = path;
                previousPathNode = pathNode;
                path = previous[path];
              }

              this.recordAllPath();
              return true;
            }
          }
        }
      }

      this.recordSteps();
    }

    if (!isVisited[endNode]) {
      return false;
    }
  };
}

Dijkstar.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FloydWarshall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function FloydWarshall(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  this.findPath = function () {
    var nodesSize = this.matrix.size;
    var beginNode = this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y);
    var endNode = this.matrix.getIndexFromXY(this.matrix.end.x, this.matrix.end.y);

    var distance = [];
    var next = [];
    for (var i = 0; i < nodesSize; i++) {
      var arr = [];
      var brr = [];
      for (var j = 0; j < nodesSize; j++) {
        arr.push(Number.POSITIVE_INFINITY);
        brr.push(-1);
      }
      distance.push(arr);
      next.push(brr);
    }
    for (var i = 0; i < nodesSize; i++) {
      for (var j = 0; j < nodesSize; j++) {
        distance[i][j] = this.matrix.graph[i][j];
        next[i][j] = j;
      }
    }

    var throughNodeCube = null;
    var ANodeCube = null;
    var BNodeCube = null;
    for (var k = 0; k < nodesSize; k++) {
      throughNodeCube = this.matrix.getCubeFromIndex(k);
      if (!throughNodeCube.isObstacle) {
        throughNodeCube.isGreenBorder = true;
        throughNodeCube.isVisited = true;
        throughNodeCube.sequence = this.sequence++;


        for (var i = 0; i < nodesSize; i++) {
          for (var j = 0; j < nodesSize; j++) {
            ANodeCube = this.matrix.getCubeFromIndex(i);
            BNodeCube = this.matrix.getCubeFromIndex(j);
            if (!ANodeCube.isObstacle && !BNodeCube.isObstacle) {
              if (distance[i][j] > distance[i][k] + distance[k][j]) {
                distance[i][j] = distance[i][k] + distance[k][j];
                next[i][j] = next[i][k];

                ANodeCube.sequence = this.sequence++;
                BNodeCube.sequence = this.sequence++;
              }
            }
          }
        }
      }
    }

    if (next[beginNode][endNode] != -1) {
      var pathNodesIndexes = [];

      var u = beginNode;
      var v = endNode;
      while (u != v) {
        u = next[u][v];
        pathNodesIndexes.push(u);
      }

      var pathNode = null;
      for (var i = pathNodesIndexes.length - 1; i > 0; i--) {
        pathNode = this.matrix.getCubeFromIndex(pathNodesIndexes[i]);
        pathNode.father = pathNodesIndexes[i - 1];
      }

      this.recordAllPath();
      return true;
    } else {
      return false;
    }
  };
}

FloydWarshall.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JumpPoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathFinder__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Connstants__ = __webpack_require__(4);





function JumpPoint(matrix) {
  __WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].call(this, matrix);

  var _openlist = [];

  function getMinOpenlist(matrix) {
    var temp = _openlist[0];
    var l = _openlist.length;
    for (var i = 1; i < l; i++) {
      if (matrix.getCubeFromIndex(_openlist[0]).F > matrix.getCubeFromIndex(_openlist[i]).F) {
        temp = _openlist[i];
        _openlist[i] = _openlist[0];
        _openlist[0] = temp;
      }
    }
  }

  function fixDirection(dx, dy) {
    var angle = Math.atan2(dy, dx);
    var degrees = 180 * angle / Math.PI;
    var index = (360 + Math.round(degrees)) % 360 / 45;
    var fixedIndex = Math.abs(index - 13) % 8;
    return fixedIndex;
  }

  this.findPath = function () {
    _openlist = [];
    var _currentCube = null;

    if (this.isBeginEndSame()) {
      return true;
    }

    _openlist.push(this.matrix.getIndexFromXY(this.matrix.begin.x, this.matrix.begin.y));
    this.matrix.getCubeFromXY(this.matrix.begin.x, this.matrix.begin.y).isOpen = true;

    while (_openlist.length > 0) {
      getMinOpenlist(this.matrix);

      _currentCube = this.matrix.getCubeFromIndex(_openlist.shift());
      this.matrix.setCubeVisited(_currentCube.x, _currentCube.y);

      if (_currentCube.x == this.matrix.end.x && _currentCube.y == this.matrix.end.y) {
        this.recordAllPath();
        return true;
      }

      this.identifySuccessors(_currentCube);
    }

    return false;
  };

  this.identifySuccessors = function (cube) {
    var neighbours = null;
    if (this.matrix.cornerWalk == __WEBPACK_IMPORTED_MODULE_3__Connstants__["a" /* CornerWalk */].Diagonal) {
      neighbours = this.findNeighboursDiagonal(cube);
    } else if (this.matrix.cornerWalk == __WEBPACK_IMPORTED_MODULE_3__Connstants__["a" /* CornerWalk */].Orthogonal) {
      neighbours = this.findNeighboursOrthogonal(cube);
    }

    for (var i = 0, l = neighbours.length; i < l; i++) {
      var neighbour = neighbours[i];

      this.recordSteps();

      var jumpPoint = null;
      if (this.matrix.cornerWalk == __WEBPACK_IMPORTED_MODULE_3__Connstants__["a" /* CornerWalk */].Diagonal) {
        jumpPoint = this.jumpDiagonal(neighbour[0], neighbour[1], cube.x, cube.y);
      } else if (this.matrix.cornerWalk == __WEBPACK_IMPORTED_MODULE_3__Connstants__["a" /* CornerWalk */].Orthogonal) {
        jumpPoint = this.jumpOrthogonal(neighbour[0], neighbour[1], cube.x, cube.y);
      }

      if (jumpPoint) {
        var jx = jumpPoint[0];
        var jy = jumpPoint[1];
        var jumpPointCube = this.matrix.getCubeFromXY(jx, jy);

        if (!jumpPointCube.isClosed) {
          var dist = this.matrix.heuristicOctile(Math.abs(jx - cube.x), Math.abs(jy - cube.y));
          var jumpPointG = cube.G + dist;

          if (!jumpPointCube.isOpen || jumpPointG < jumpPointCube.G) {
            jumpPointCube.G = jumpPointG;
            jumpPointCube.H = jumpPointCube.H || this.matrix.heuristicToEnd(jx, jy);
            jumpPointCube.F = jumpPointCube.G + jumpPointCube.H;

            if (!jumpPointCube.isOpen) {
              _openlist.push(this.matrix.getIndexFromXY(jx, jy));
              jumpPointCube.isOpen = true;

              jumpPointCube.isGreenBorder = true;
              jumpPointCube.isVisited = true;
            } else {}
          }

          this.recordSteps();
        }
      }
    }
  };

  this.findNeighboursDiagonal = function (cube) {
    var neighbours = [];

    if (cube.father) {
      var cubeFather = this.matrix.getCubeFromIndex(cube.father);
      var x = cube.x;
      var y = cube.y;
      var fx = cubeFather.x;
      var fy = cubeFather.y;

      var dx = (x - fx) / Math.max(Math.abs(x - fx), 1);
      var dy = (y - fy) / Math.max(Math.abs(y - fy), 1);

      if (dx !== 0 && dy !== 0) {
        if (this.matrix.isCubeWalkable(x, y + dy)) {
          neighbours.push([x, y + dy]);
        }

        if (this.matrix.isCubeWalkable(x + dx, y)) {
          neighbours.push([x + dx, y]);
        }

        if (this.matrix.isCubeWalkable(x, y + dy) || this.matrix.isCubeWalkable(x + dx, y)) {
          neighbours.push([x + dx, y + dy]);
        }
        if (!this.matrix.isCubeWalkable(x - dx, y) && this.matrix.isCubeWalkable(x, y + dy)) {
          neighbours.push([x - dx, y + dy]);
        }
        if (!this.matrix.isCubeWalkable(x, y - dy) && this.matrix.isCubeWalkable(x + dx, y)) {
          neighbours.push([x + dx, y - dy]);
        }
      } else {
        if (dx === 0) {
          if (this.matrix.isCubeWalkable(x, y + dy)) {
            neighbours.push([x, y + dy]);

            if (!this.matrix.isCubeWalkable(x + 1, y)) {
              neighbours.push([x + 1, y + dy]);
            }
            if (!this.matrix.isCubeWalkable(x - 1, y)) {
              neighbours.push([x - 1, y + dy]);
            }
          }
        } else {
          if (this.matrix.isCubeWalkable(x + dx, y)) {
            neighbours.push([x + dx, y]);

            if (!this.matrix.isCubeWalkable(x, y + 1)) {
              neighbours.push([x + dx, y + 1]);
            }
            if (!this.matrix.isCubeWalkable(x, y - 1)) {
              neighbours.push([x + dx, y - 1]);
            }
          }
        }
      }
    } else {
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = cube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = cube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(cube.x, cube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isClosed && !deltaCube.isOpen) {
            neighbours.push([deltaCubeX, deltaCubeY]);
          }
        }
      }
    }

    return neighbours;
  };

  this.jumpDiagonal = function (x, y, fx, fy) {
    var dx = x - fx;
    var dy = y - fy;
    var fixedIndex = fixDirection(dx, dy);

    if (!this.matrix.isCubeWalkable(x, y)) {
      return null;
    }

    var cube = this.matrix.getCubeFromXY(x, y);
    if (!cube.isVisited) {
      cube.isBlueBorder = true;
      cube.isVisited = true;
      this.matrix.setCubeFather(x, y, this.matrix.getIndexFromXY(fx, fy), __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][fixedIndex]);
    }

    if (x == this.matrix.end.x && y == this.matrix.end.y) {
      return [x, y];
    }

    if (dx !== 0 && dy !== 0) {
      if (this.matrix.isCubeWalkable(x - dx, y + dy) && !this.matrix.isCubeWalkable(x - dx, y) || this.matrix.isCubeWalkable(x + dx, y - dy) && !this.matrix.isCubeWalkable(x, y - dy)) {
        return [x, y];
      }

      if (this.jumpDiagonal(x + dx, y, x, y) || this.jumpDiagonal(x, y + dy, x, y)) {
        return [x, y];
      }
    } else {
      if (dx !== 0) {
        if (this.matrix.isCubeWalkable(x + dx, y + 1) && !this.matrix.isCubeWalkable(x, y + 1) || this.matrix.isCubeWalkable(x + dx, y - 1) && !this.matrix.isCubeWalkable(x, y - 1)) {
          return [x, y];
        }
      } else {
        if (this.matrix.isCubeWalkable(x + 1, y + dy) && !this.matrix.isCubeWalkable(x + 1, y) || this.matrix.isCubeWalkable(x - 1, y + dy) && !this.matrix.isCubeWalkable(x - 1, y)) {
          return [x, y];
        }
      }
    }

    if (this.matrix.isCubeWalkable(x + dx, y) || this.matrix.isCubeWalkable(x, y + dy)) {
      return this.jumpDiagonal(x + dx, y + dy, x, y);
    } else {
      return null;
    }
  };

  this.findNeighboursOrthogonal = function (cube) {
    var neighbours = [];

    if (cube.father) {
      var cubeFather = this.matrix.getCubeFromIndex(cube.father);
      var x = cube.x;
      var y = cube.y;
      var fx = cubeFather.x;
      var fy = cubeFather.y;

      var dx = (x - fx) / Math.max(Math.abs(x - fx), 1);
      var dy = (y - fy) / Math.max(Math.abs(y - fy), 1);

      if (dx !== 0) {
        if (this.matrix.isCubeWalkable(x, y - 1)) {
          neighbours.push([x, y - 1]);
        }
        if (this.matrix.isCubeWalkable(x, y + 1)) {
          neighbours.push([x, y + 1]);
        }
        if (this.matrix.isCubeWalkable(x + dx, y)) {
          neighbours.push([x + dx, y]);
        }
      } else if (dy !== 0) {
        if (this.matrix.isCubeWalkable(x - 1, y)) {
          neighbours.push([x - 1, y]);
        }
        if (this.matrix.isCubeWalkable(x + 1, y)) {
          neighbours.push([x + 1, y]);
        }
        if (this.matrix.isCubeWalkable(x, y + dy)) {
          neighbours.push([x, y + dy]);
        }
      }
    } else {
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_3__Connstants__["f" /* DeltaLength */]; i++) {
        var deltaCubeX = cube.x + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].x;
        var deltaCubeY = cube.y + __WEBPACK_IMPORTED_MODULE_3__Connstants__["c" /* Delta */][i].y;
        if (this.matrix.isDeltaCubeWalkable(cube.x, cube.y, i)) {
          var deltaCube = this.matrix.getCubeFromXY(deltaCubeX, deltaCubeY);
          if (!deltaCube.isClosed && !deltaCube.isOpen) {
            neighbours.push([deltaCubeX, deltaCubeY]);
          }
        }
      }
    }

    return neighbours;
  };

  this.jumpOrthogonal = function (x, y, fx, fy) {
    var dx = x - fx;
    var dy = y - fy;
    var fixedIndex = fixDirection(dx, dy);

    if (!this.matrix.isCubeWalkable(x, y)) {
      return null;
    }

    var cube = this.matrix.getCubeFromXY(x, y);
    if (!cube.isVisited) {
      cube.isBlueBorder = true;
      cube.isVisited = true;
      this.matrix.setCubeFather(x, y, this.matrix.getIndexFromXY(fx, fy), __WEBPACK_IMPORTED_MODULE_3__Connstants__["g" /* DeltaReversedDirection */][fixedIndex]);
    }

    if (x == this.matrix.end.x && y == this.matrix.end.y) {
      return [x, y];
    }

    if (dx !== 0) {
      if (this.matrix.isCubeWalkable(x, y - 1) && !this.matrix.isCubeWalkable(x - dx, y - 1) || this.matrix.isCubeWalkable(x, y + 1) && !this.matrix.isCubeWalkable(x - dx, y + 1)) {
        return [x, y];
      }
    } else if (dy !== 0) {
      if (this.matrix.isCubeWalkable(x - 1, y) && !this.matrix.isCubeWalkable(x - 1, y - dy) || this.matrix.isCubeWalkable(x + 1, y) && !this.matrix.isCubeWalkable(x + 1, y - dy)) {
        return [x, y];
      }

      if (this.jumpOrthogonal(x + 1, y, x, y) || this.jumpOrthogonal(x - 1, y, x, y)) {
        return [x, y];
      }
    } else {
      throw new Error("Only horizontal and vertical movements are allowed");
    }

    return this.jumpOrthogonal(x + dx, y + dy, x, y);
  };
}

JumpPoint.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__PathFinder__["a" /* PathFinder */].prototype), {});



/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AStar__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JumpPoint__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BiAStar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AStarHeap__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BiAStarHeap__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BFS__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BiBFS__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DFS__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BiDFS__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Dijkstar__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FloydWarshall__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AStar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__JumpPoint__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__BiAStar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__AStarHeap__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__BiAStarHeap__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__BFS__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__BiBFS__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__DFS__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__BiDFS__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__Dijkstar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__FloydWarshall__["a"]; });














/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isLoading: function isLoading(state) {
    return state.isLoading;
  },

  matrix: function matrix(state) {
    return state.matrix;
  },

  lastClickedCubeIndex: function lastClickedCubeIndex(state) {
    return state.lastClickedCubeIndex;
  },
  selectedCubeType: function selectedCubeType(state) {
    return state.selectedCubeType;
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  UPDATE_ISLOADING: function UPDATE_ISLOADING(state, isLoading) {
    state.isLoading = isLoading;
  },

  UPDATE_MATRIX: function UPDATE_MATRIX(state, matrix) {
    state.matrix = matrix;
  },

  UPDATE_LAST_CLICKED_CUBE_INDEX: function UPDATE_LAST_CLICKED_CUBE_INDEX(state, index) {
    state.lastClickedCubeIndex = index;
  },

  UPDATE_SELECTED_CUBE_TYPE: function UPDATE_SELECTED_CUBE_TYPE(state, type) {
    state.selectedCubeType = type;
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isLoading: false,

  matrix: '',

  lastClickedCubeIndex: '',
  selectedCubeType: ''
});

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(149)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(157),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2980d96e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(150)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(158),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4818160e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(160),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a503abd4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "controls"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.run
    }
  }, [_vm._v(_vm._s(_vm.$t('run')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.clear
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('reset')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isPreviousButton
    },
    on: {
      "click": _vm.previous
    }
  }, [_vm._v(_vm._s(_vm.$t('previous')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isNextButton
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t('next')))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    on: {
      "change": _vm.selectFinder
    },
    model: {
      value: (_vm.finder),
      callback: function($$v) {
        _vm.finder = $$v
      },
      expression: "finder"
    }
  }, _vm._l((_vm.finders), function(f) {
    return _c('el-option', {
      key: f.value,
      attrs: {
        "label": f.label,
        "value": f.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-row', [_c('el-radio-group', {
    on: {
      "change": _vm.selectCornerWalk
    },
    model: {
      value: (_vm.cornerWalk),
      callback: function($$v) {
        _vm.cornerWalk = $$v
      },
      expression: "cornerWalk"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Orthogonal"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Diagonal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-radio-group', {
    on: {
      "change": _vm.selectHeuristic
    },
    model: {
      value: (_vm.heuristic),
      callback: function($$v) {
        _vm.heuristic = $$v
      },
      expression: "heuristic"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "Manhattan"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Euclidean"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Octile"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Chebyshev"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "matrix"
  }, _vm._l((100), function(n) {
    return _c('cube', {
      key: n,
      attrs: {
        "index": n
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cube",
    class: [_vm.cubeType, _vm.borderType],
    style: ({
      'grid-row': _vm.gridR,
      'grid-column': _vm.gridC
    }),
    on: {
      "mousedown": _vm.cubeMouseDown,
      "mouseup": _vm.cubeMouseUp,
      "mouseenter": _vm.cubeMouseEnter
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cube.isShowFGH),
      expression: "cube.isShowFGH"
    }],
    staticClass: "H"
  }, [_vm._v(_vm._s(_vm.cube.H))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cube.isShowFGH),
      expression: "cube.isShowFGH"
    }],
    staticClass: "G"
  }, [_vm._v(_vm._s(_vm.cube.G))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cube.isShowFGH),
      expression: "cube.isShowFGH"
    }],
    staticClass: "F"
  }, [_vm._v(_vm._s(_vm.cube.F))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cube.sequence != 0),
      expression: "cube.sequence != 0"
    }],
    staticClass: "S"
  }, [_vm._v(_vm._s(_vm.cube.sequence))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cube.fatherDirection),
      expression: "cube.fatherDirection"
    }],
    staticClass: "parent",
    style: ({
      transform: _vm.direction
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cube.isVisited),
      expression: "cube.isVisited"
    }],
    staticClass: "indicator",
    class: _vm.indicatorType
  })])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "tutorial"
  }, [_c('el-row', {
    staticClass: "tutorial-row"
  }, [_c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-begin"
  }, [_vm._v("Begin")])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-end"
  }, [_vm._v("End")])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_vm._v("Path")])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-obstacle"
  }, [_vm._v("Obstacle")])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube"
  }, [_c('div', {
    staticClass: "parent",
    staticStyle: {
      "transform": "rotate(270deg)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }, [_vm._v("Visited")]), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Parent\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube"
  }, [_c('div', {
    staticClass: "parent",
    staticStyle: {
      "transform": "rotate(270deg)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-path"
  }, [_vm._v("Path")]), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Parent\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_c('div', {
    staticClass: "H line-height-font-size"
  }, [_vm._v("10(H)")]), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Heuristic\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_c('div', {
    staticClass: "G line-height-font-size"
  }, [_vm._v("20(G)")]), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Moving Cost\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_c('div', {
    staticClass: "F line-height-font-size"
  }, [_vm._v("30(F)")]), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Weight\n        ")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "tutorial-col tutorial-left"
  }, [_c('div', {
    staticClass: "tutorial-cube cube-path"
  }, [_c('div', {
    staticClass: "S line-height-font-size"
  }, [_vm._v("10")]), _vm._v(" "), _c('div', {
    staticClass: "indicator indicator-visited"
  }), _vm._v(" "), _c('div', {
    staticClass: "tutorial-cube-text"
  }, [_vm._v("\n          Visiting Index\n        ")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('matrix'), _vm._v(" "), _c('controls'), _vm._v(" "), _c('tutorial'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._v("Project Hosted on "), _c('a', {
    attrs: {
      "href": "https://github.com/hmeng22/pathfinder",
      "target": "_blank"
    }
  }, [_vm._v("Github")])])
}]}

/***/ })
],[87]);


// WEBPACK FOOTER //
// static/js/app.0e1c0b79e17ff054decb.js